import { Component, OnInit, Input } from '@angular/core'
import { AuthService } from '@spartacus/core'
import { FormControl, Validators, FormGroup } from '@angular/forms'
import { Router, ActivatedRoute } from '@angular/router'
import { Observable } from 'rxjs'
import { GlobalMessageType, GlobalMessageService } from '@spartacus/core'
import { MyFavouritesService } from '../my-favourites.service'
import { LaunchDialogService } from '@spartacus/storefront'
import { QuoteCartService } from '../../quote/quote-services/quote-cart.service'

import {
  ActiveCartFacade,
  MultiCartFacade,
  OrderEntry,
} from '@spartacus/cart/base/root'
import { take } from 'rxjs/operators'
import {
  ACCESSIBILITY,
  UserRoleService,
} from '../../../shared/services/user-role.service'
import { CommonService } from '../../../shared/services/common.service'
import { VS_LAUNCH_CALLER } from '../../config/dialog.config'
import {
  Ecommerce,
  EcommerceItem,
  GTMDataLayer,
} from '../../../shared/models/googleTagManager.model';
import {
  ItemListTypeEnum,
  GtmEvents,
  StoreTypeEnum,
} from '../../../shared/enums/gtm.enum';
import { GoogleTagManagerService } from '../../../shared/services/gtm.service';

@Component({
  standalone: false,
  selector: 'vs-my-favourites-list',
  templateUrl: './my-favourites-list.component.html',
  styleUrls: ['./my-favourites-list.component.scss'],
})
export class MyFavouritesListComponent implements OnInit {
  userType: string
  loggedIn: boolean
  itemsPerPage = 50
  currentPageNumber = 0
  @Input() quantity: FormControl = new FormControl(1)
  @Input() readonly = false
  isMasterSel: boolean = false
  checkedProductList: any = []
  client: any = { indeterminated: false, checked: false }
  currentUser: any
  cartEntry$: Observable<OrderEntry>
  cartId: any
  increment = false
  productsList: any
  fullResponse: any
  public searchId: string = ''
  public searchText: string
  public searchFilter: boolean
  public noData: boolean
  params: any
  form = new FormGroup({})
  rfqCartId: any
  cartShopping$: Observable<any> = this.activeCartFacade.getActiveCartId()
  getEntriesShoppingCArt$: Observable<any> = this.activeCartFacade.getEntries()
  displayLoader: boolean = true
  accessibility = ACCESSIBILITY

  constructor(
    private auth: AuthService,
    public commonService: CommonService,
    public routes: ActivatedRoute,
    public router: Router,
    private globalMessageService: GlobalMessageService,
    private myFavouritesService: MyFavouritesService,
    protected activeCartFacade: ActiveCartFacade,
    protected launchDialogService: LaunchDialogService,
    public quoteService: QuoteCartService,
    private multiCartFacade: MultiCartFacade,
    private userRoleService: UserRoleService,
    private gtmService: GoogleTagManagerService
  ) {}

  ngOnInit(): void {
    this.checkUserLoggedInStatus()
    this.activeCartFacade.getActiveCartId().subscribe((data) => {
      this.cartId = data
    })
    this.routes.queryParams.subscribe((params: any) => {
      if (params.currentPage !== undefined) {
        this.currentPageNumber = params.currentPage
      }
    })
    this.fetchRfqCartID()
    this.populateFavoritesList()
  }

  gtmSelectItemEvent(product) {
    let producitem: EcommerceItem[] = [];
    if (product) {
      producitem.push({
        item_id: product?.code,
        item_name: product?.name,
        discount: product?.discountPercentage
          ? + product?.discountPercentage
          : '',
        index: 0,
        item_list_id: ItemListTypeEnum.MyFavourite,
        item_list_name: ItemListTypeEnum.MyFavourite,
        price: '', //discountPrice not available
      });
      let purchaseEcommerceEcommerce: Ecommerce = {
        item_list_id: ItemListTypeEnum.MyFavourite,
        item_list_name: ItemListTypeEnum.MyFavourite,
        items: producitem,
      };
      let selectItemDataLayer: GTMDataLayer = {
        event: GtmEvents.SelectItem,
        ecommerce: purchaseEcommerceEcommerce,
      };
      this.gtmService.sendEvent(selectItemDataLayer);
    }
  }

  getProductImageUrl(productObj) {
    //Code to decide the URL for the image based on response
    if (
      productObj != undefined &&
      productObj.product != undefined &&
      productObj.product.images != undefined
    ) {
      return productObj?.product?.images[0]
    } else if (productObj != undefined && productObj.product != undefined) {
      return productObj?.product?.url
    } else {
      return ''
    }
  }

  checkUserLoggedInStatus() {
    this.auth.isUserLoggedIn().subscribe((success) => {
      if (success) {
        this.loggedIn = true
        this.userType = 'current'
      } else {
        this.loggedIn = false
        this.userType = 'anonymous'
      }
    })

    this.commonService.getUserData().subscribe(
      (user) => {
        this.currentUser = user
      },
      (err) => {}
    )
  }

  updateProductsListWithQuantitiesOpted(productItem) {
    for (var i = 0; i < this.productsList.length; i++) {
      if (this.productsList[i].product.code === productItem.product.code) {
        this.productsList[i].quantity = this.form.get(
          productItem.product.code
        ).value
      }
    }
  }

  getCartId() {
    this.cartShopping$ = this.activeCartFacade.getActiveCartId()
    this.cartShopping$.subscribe((data) => {
      this.cartId = data
    })
  }
  addProductToBuyCart(productChosen) {
    this.cartEntry$ = this.activeCartFacade.getEntry(productChosen.product.code)
    this.getCartId()

    if (!productChosen.product.obsoleteProductFlag) {
      this.updateProductsListWithQuantitiesOpted(productChosen)

      this.myFavouritesService
        .postProductsToBUYCart([productChosen], this.cartId)
        .subscribe(
          (response) => {
            this.openModal(productChosen)
          },
          (error) => {
            this.globalMessageService.add(
              { key: 'myFavourites.issueWhileAddingToShopCart' },
              GlobalMessageType.MSG_TYPE_ERROR,
              5000
            )
            window.scrollTo(0, 0)
          }
        )
    }
  }

  private openModal(productChosen) {
    //CODE IS USED TO //1. GET THE CART ID & //2. REFRESH THE CART
    this.activeCartFacade.getActiveCartId().subscribe((res) => {
      this.multiCartFacade.loadCart({
        userId: 'current',
        cartId: res,
        extraData: {
          active: true,
        },
      })
    })

    this.cartEntry$ = this.activeCartFacade.getEntry(productChosen.product.code)

    const componentdata = {
      entry$: this.cartEntry$,
      cart$: this.activeCartFacade.getActive(),
      loaded$: this.activeCartFacade.isStable(),
      quantity: productChosen.quantity,
      increment: this.increment,
      product: productChosen.product,
    }

    const addToCartDialog = this.launchDialogService.openDialog(
      VS_LAUNCH_CALLER.ADD_TO_CART,
      undefined,
      undefined,
      componentdata
    )
    if (addToCartDialog) {
      addToCartDialog.pipe(take(1)).subscribe((value) => {})
      this.launchDialogService.dialogClose.subscribe((value) => {})
    }
  }

  fetchRfqCartID() {
    this.quoteService.recieveCartId.subscribe((cartId) => {
      if (cartId) {
        this.rfqCartId = cartId
      }
    })
  }

  configureQuoteCartId() {
    this.rfqCartId = sessionStorage.getItem('cartId-' + this.userType)
    this.quoteService
      .getCart(this.rfqCartId, this.userType)
      .subscribe((success) => {
        if (this.loggedIn || this.userType === 'current') {
          sessionStorage.setItem('cartStatus-current', 'added')
        }
        if (!this.loggedIn || this.userType === 'anonymous') {
          sessionStorage.setItem('cartStatus-anonymous', 'added')
        }
      })
  }

  addProductToQuoteCart(productChosen) {
    this.updateProductsListWithQuantitiesOpted(productChosen)
    this.configureQuoteCartId()
    this.myFavouritesService
      .postProductsToQUOTECart([productChosen], this.rfqCartId)
      .subscribe(
        (data) => {
          this.openQuoteModal(productChosen)
        },
        (error) => {
          this.globalMessageService.add(
            { key: 'myFavourites.issueWhileAddingToQuoteCart' },
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scrollTo(0, 0)
        }
      )
  }

  openQuoteModal(productChosen) {
    var obj = {
      product: productChosen.product,
      userType: this.userType,
      cartId: this.rfqCartId,
      type: 'catalog',
      quantity: productChosen.quantity,
    }
    this.commonService.sendProduct(obj)
    const componentdata = {}

    const singleQuoteDialog = this.launchDialogService.openDialog(
      VS_LAUNCH_CALLER.SINGLE_QUOTE,
      undefined,
      undefined,
      componentdata
    )
    if (singleQuoteDialog) {
      singleQuoteDialog.pipe(take(1)).subscribe((value) => {})
      this.launchDialogService.dialogClose.subscribe((value) => {})
    }
  }

  removeProductFromFavList(productChosen) {
    const removeProductList = []
    removeProductList.push(productChosen.product.code)
    this.myFavouritesService.removeProducts(removeProductList).subscribe(
      (response) => {
        if (this.productsList.length === removeProductList.length) {
          //if all the products on a particular page are selected,
          //then implement this logic to fetch products from previous page
          if (this.currentPageNumber !== 0) {
            this.currentPageNumber--
          }
        }
        this.populateFavoritesList()

        this.globalMessageService.add(
          { key: 'myFavourites.itemsRemovedFromFav' },
          GlobalMessageType.MSG_TYPE_CONFIRMATION,
          5000
        )
        window.scrollTo(0, 0)
      },
      (error) => {
        this.globalMessageService.add(
          { key: 'myFavourites.issuewhileremovingFav' },
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
  }

  onMasterClick(cliente: any, event) {
    this.isMasterSel = event.target.checked
    cliente.checked = event.target.checked
    cliente.indeterminated = false
    this.bulkProductSelection()
  }
  resetMasterCheckBox() {
    this.client = { indeterminated: false, checked: false }
  }
  onProductSelect(productItem, index, event) {
    this.isMasterSel = false
    productItem.product.selected = event.target.checked

    this.isMasterSel
      ? (this.client.indeterminated = false)
      : (this.client.indeterminated = true)

    this.resetMasterCheckBox()
    this.getCheckedItemList()

    if (!event.target.checked) {
      this.client.indeterminated = true
      this.client.checked = false
      this.checkListForCompletelyUnselected()
    } else {
      this.client.indeterminated = true
      this.client.checked = false
      this.checkListForCompletelySelected()
    }
  }

  checkListForCompletelyUnselected() {
    let productTracker = []
    for (let i = 0; i < this.productsList.length; i++) {
      if (this.productsList[i].product.selected) {
        productTracker.push(this.productsList[i])
      }
    }

    //if you find any products on this page which is not checked then report here
    if (productTracker.length > 0) {
      this.client.indeterminated = true //keep master checkbox in indeterminate state
      this.client.checked = false
    } else {
      this.client.indeterminated = false //don't keep master checkbox in indeterminate state
      this.client.checked = false //keep master checkbox in non-checked state
    }
  }

  checkListForCompletelySelected() {
    let productTracker = []
    for (let i = 0; i < this.productsList.length; i++) {
      if (!this.productsList[i].product.selected) {
        productTracker.push(this.productsList[i])
      }
    }
    //if you find any products on this page which is not checked then report here
    if (productTracker.length > 0) {
      this.client.indeterminated = true //keep master checkbox in indeterminate state
      this.client.checked = false
    } else {
      this.client.indeterminated = false //don't keep master checkbox in indeterminate state
      this.client.checked = true //keep master checkbox in checked state
    }
  }

  bulkProductsRefreshQuantity() {
    for (var i = 0; i < this.productsList.length; i++) {
      this.productsList[i].quantity = this.form.get(
        this.productsList[i].product.code
      ).value
    }
  }

  bulkProductSelection() {
    this.isMasterSel = this.client.checked ? true : false
    for (var i = 0; i < this.productsList.length; i++) {
      this.productsList[i].product.selected = this.isMasterSel
    }
    this.getCheckedItemList()
  }

  getCheckedItemList() {
    this.checkedProductList = []
    for (var i = 0; i < this.productsList.length; i++) {
      if (this.productsList[i].product.selected)
        this.checkedProductList.push(this.productsList[i])
    }
  }

  private openFavoriteModal(
    productsEligible,
    productsNotEligible,
    flowIndicator
  ) {
    //CODE IS USED TO //1. GET THE CART ID & //2. REFRESH THE CART
    this.activeCartFacade.getActiveCartId().subscribe((res) => {
      this.multiCartFacade.loadCart({
        userId: 'current',
        cartId: res,
        extraData: {
          active: true,
        },
      })
    })
    let componentdata = {
      productsEligible: productsEligible,
      productsNotEligible: productsNotEligible,
      flowIndicator: flowIndicator,
      loaded$: flowIndicator == 'BUY' ? this.activeCartFacade.isStable() : true,
      cart$: flowIndicator == 'BUY' ? this.activeCartFacade.getActive() : '',
    }

    const myFavouritesDialog = this.launchDialogService.openDialog(
      VS_LAUNCH_CALLER.MY_FAVOURITES,
      undefined,
      undefined,
      componentdata
    )
    if (myFavouritesDialog) {
      myFavouritesDialog.pipe(take(1)).subscribe((value) => {})
      this.launchDialogService.dialogClose.subscribe((value) => {})
    }
  }

  bulkBuy() {
    this.bulkProductsRefreshQuantity()
    this.getCartId()
    //separate obslte flag products and put into 2 separate lists to BUY
    let productsEligibleToBuy = []
    let productsNotEligibleToBuy = []
    for (let productItem of this.checkedProductList) {
      if (!this.checkProductEligibleToBuy(productItem)) {
        productsNotEligibleToBuy.push(productItem)
      } else {
        productsEligibleToBuy.push(productItem)
      }
    }

    if (
      this.checkedProductList !== undefined &&
      this.checkedProductList.length > 0 &&
      !(
        productsEligibleToBuy.length == 0 && productsNotEligibleToBuy.length > 0
      )
    ) {
      this.myFavouritesService
        .postProductsToBUYCart(productsEligibleToBuy, this.cartId)
        .subscribe(
          (response) => {
            this.openFavoriteModal(
              productsEligibleToBuy,
              productsNotEligibleToBuy,
              'BUY'
            )
          },
          (error) => {
            this.globalMessageService.add(
              { key: 'myFavourites.issueWhileAddingToShopCart' },
              GlobalMessageType.MSG_TYPE_ERROR,
              5000
            )
            window.scrollTo(0, 0)
          }
        )
    }
  }

  bulkQuote() {
    this.bulkProductsRefreshQuantity()
    this.configureQuoteCartId()

    if (
      this.checkedProductList !== undefined &&
      this.checkedProductList.length > 0
    ) {
      this.myFavouritesService
        .postProductsToQUOTECart(this.checkedProductList, this.rfqCartId)
        .subscribe(
          (data) => {
            this.openFavoriteModal(this.checkedProductList, [], 'QUOTE')
          },
          (error) => {
            this.globalMessageService.add(
              { key: 'myFavourites.issueWhileAddingToQuoteCart' },
              GlobalMessageType.MSG_TYPE_ERROR,
              5000
            )
            window.scrollTo(0, 0)
          }
        )
    }
  }

  bulkRemove() {
    if (
      this.checkedProductList !== undefined &&
      this.checkedProductList.length > 0
    ) {
      const removeProductList = []
      for (let productItem of this.checkedProductList) {
        removeProductList.push(productItem.product.code)
      }

      this.myFavouritesService.removeProducts(removeProductList).subscribe(
        (response) => {
          if (this.productsList.length === removeProductList.length) {
            //if all the products on a particular page are selected,
            //then implement this logic to fetch products from previous page
            if (this.currentPageNumber !== 0) {
              this.currentPageNumber--
            }
          }
          this.populateFavoritesList()
          this.resetMasterCheckBox()
          this.globalMessageService.add(
            { key: 'myFavourites.itemsRemovedFromFav' },
            GlobalMessageType.MSG_TYPE_CONFIRMATION,
            5000
          )
          window.scrollTo(0, 0)
        },
        (error) => {
          this.globalMessageService.add(
            { key: 'myFavourites.issuewhileremovingFav' },
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scrollTo(0, 0)
        }
      )
    }
  }

  onProductQtyIncrement(product) {
    product.quantity++
  }

  onProductQtyDecrement(product) {
    product.quantity--
  }

  displayMessageToUser(messageToUser, messageType, time) {
    this.globalMessageService.add(messageToUser, messageType, time)
  }

  currentPage(event) {
    this.displayLoader = true
    this.fullResponse = []
    this.currentPageNumber = event
    this.isMasterSel = false
    this.resetMasterCheckBox()
    this.populateFavoritesList()
  }

  keyUp(search, event) {
    if (event.keyCode === 13) {
      this.noData = false
      this.searchFilter = true
      this.displayLoader = true
      this.populateSearchList(search)
    }
  }

  modelChange(search) {
    this.noData = false
    this.searchFilter = true
    this.displayLoader = true
    this.populateSearchList(search)
  }

  clearSearchFilter() {
    this.noData = false
    this.searchText = null
    this.searchFilter = false
    this.displayLoader = true
    this.populateFavoritesList()
  }

  populateSearchList(search) {
    this.searchText = search
    this.searchId = search.trim()
    this.myFavouritesService
      .fetchFavoritesList(
        this.currentPageNumber,
        this.itemsPerPage,
        this.searchId
      )
      .subscribe(
        (response) => {
          if (response !== null && response !== undefined) {
            this.fullResponse = response
            this.productsList = response['wishlist2EntryList']
            if (this.productsList.length == 0) {
              this.noData = true
            }
            for (let productItem of this.productsList) {
              productItem.product['selected'] = false
            }
            this.productsList.forEach((productItem) => {
              this.form.addControl(
                productItem.product.code,
                new FormControl(productItem.quantity, Validators.required)
              )
            })
            this.displayLoader = false
          } else {
            this.noData = true
          }
        },
        (error) => {
          this.displayLoader = false
          this.globalMessageService.add(
            { key: 'myFavourites.issueWhileLoad' },
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scrollTo(0, 0)
        }
      )
  }

  populateFavoritesList() {
    this.myFavouritesService
      .fetchFavoritesList(this.currentPageNumber, this.itemsPerPage, '')
      .subscribe(
        (response) => {
          if (response !== null && response !== undefined) {
            this.fullResponse = response
            this.productsList = response['wishlist2EntryList']

            for (let productItem of this.productsList) {
              productItem.product['selected'] = false
            }
            this.productsList.forEach((productItem) => {
              this.form.addControl(
                productItem.product.code,
                new FormControl(productItem.quantity, Validators.required)
              )
            })
            this.displayLoader = false
          }
        },
        (error) => {
          this.displayLoader = false
          this.globalMessageService.add(
            { key: 'myFavourites.issueWhileLoad' },
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scrollTo(0, 0)
        }
      )
  }

  ngOnDestroy() {}

  checkProductEligibleToBuy(productObj) {
    //check for sellability flag
    //check for obsolete
    //check for price value
    if (
      productObj?.product !== undefined &&
      productObj?.product['sellabilityFlag'] !== undefined &&
      productObj?.product['sellabilityFlag'] === true &&
      ((productObj?.product['obsoleteProductFlag'] !== undefined &&
        productObj?.product['obsoleteProductFlag'] === false) ||
        productObj?.product['obsoleteProductFlag'] === undefined) &&
      productObj?.product['price'] !== undefined &&
      productObj?.product['price'].value !== undefined &&
      productObj?.product['price'].value !== 0 &&
      productObj.product['displayAlternativetext'] !== undefined &&
      productObj?.product['displayAlternativetext'] === false
    ) {
      return true
    } else {
      return false
    }
  }

  checkUserEnabled(flagName) {
    return this.userRoleService.checkUserRoleEnabled(flagName)
  }
}
